import { RegisterForm } from './components/register-form'

function PageRegisterView() {
  return <RegisterForm />
}

export { PageRegisterView }
